import {
  MANPOWER_CERTIFICATE_FETCHING,
  MANPOWER_CERTIFICATE_FAILED,
  MANPOWER_CERTIFICATE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MANPOWER_CERTIFICATE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case MANPOWER_CERTIFICATE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case MANPOWER_CERTIFICATE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
